import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CodeInputPage } from './code-input';
import { IonDigitKeyboard } from '../../components/ion-digit-keyboard/ion-digit-keyboard.module';

@NgModule({
  declarations: [
    CodeInputPage,
  ],
  imports: [
    IonDigitKeyboard,
    IonicPageModule.forChild(CodeInputPage),
  ],
})
export class CodeInputPageModule {}



// WEBPACK FOOTER //
// ./src/pages/code-input/code-input.module.ts